import { MenuItem } from "@mantine/core"
import { IconBrandAndroid, IconBrandApple } from "@tabler/icons-react"
import Link from "next/link"

export function MenuItemInstallMobileAppButton({ platform }: { platform: "ios" | "android" }) {
  return (
    <MenuItem
      leftSection={platform === "android" ? <IconBrandAndroid size={16} /> : <IconBrandApple size={16} />}
      component={Link}
      href={platform === "android" ? "https://play.google.com/store/apps/details?id=com.ringio.app" : "https://apps.apple.com/us/app/ring-io-power-dialer/id1631392085"}
      target="_blank"
    >
      {platform === "android" ? "Android" : "iOS"} App
    </MenuItem>
  )
}
